
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/data-grid/export-print",
      function () {
        return require("private-next-pages/x/api/data-grid/export-print.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/data-grid/export-print"])
      });
    }
  